import advanceToPlayerProtection from "./advanceToPlayerProtection.ts";
import autoProtect from "./autoProtect.ts";
import finalize from "./finalize.ts";
import start from "./start.ts";
import updateProtectedPids from "./updateProtectedPids.ts";

export default {
	advanceToPlayerProtection,
	autoProtect,
	finalize,
	start,
	updateProtectedPids,
};
